import "./src/styles/global.css"
import React from "react"
import Layout from "./src/components/layout"
export const onInitialClientRender = () => {
  setTimeout(function () {
    const loaderElement = document.getElementById("___loader")
    if (loaderElement) {
      loaderElement.style.display = "none"
    }
  }, 1000)
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// gatsby-browser.js
let devtoolsOpen = false

export const onClientEntry = () => {
  // Detect F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+U
  document.addEventListener("keydown", (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey &&
        e.shiftKey &&
        ["i", "j", "c"].includes(e.key.toLowerCase())) ||
      (e.ctrlKey && e.key.toLowerCase() === "u")
    ) {
      e.preventDefault()
      const pin = prompt("Enter PIN to access developer tools:")
      if (pin !== "Y123") {
        alert("Access denied")
        window.location.href = "/"
      } else {
        devtoolsOpen = true
      }
    }
  })

  // Periodically check for devtools
  function isMobileDevice() {
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0
    const isMobileUA =
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    return hasTouch || isMobileUA
  }

  setInterval(() => {
    if (isMobileDevice()) return // Skip detection on mobile

    const widthThreshold = window.outerWidth - window.innerWidth > 160
    const heightThreshold = window.outerHeight - window.innerHeight > 160

    if ((widthThreshold || heightThreshold) && !devtoolsOpen) {
      const pin = prompt("Enter PIN to continue using developer tools:")
      if (pin !== "Y123") {
        window.location.href = "https://www.google.com/"
      } else {
        devtoolsOpen = true
      }
    }
  }, 1000)
}
